export const api = {
	saleSummary: '/report/saleSummary',
	exportSaleSummary: '/report/exportSaleSummary'
};

export const routes = {
	'/sales-catering-summary': '销售分餐汇总',
};
